<script lang="ts" setup>
import { ShowcaseLayout, ActionBarLayout } from '@Shared';
import useCompanyImageBaseUrl from '@Use/useCompanyImageBaseUrl';
import { useCompanyStore } from '@Stores/company.store';
import { useLocationStore } from '@Stores/location.store';
import useFlowNavigation from '@Use/useFlowNavigation';
import { LINKS } from '@Constants/links.constants';
import ShowcaseImage from '@Components/ShowcaseImage.vue';

// Stores / base data
const companyImageBaseUrl = useCompanyImageBaseUrl();
const companyStore = useCompanyStore();
const locationStore = useLocationStore();

// Flow navigation
const { advanceFlow, navigateToWhatsNext } = useFlowNavigation();

// Actions
const continueFlow = () => {
    // Any tracking code or logic here
    advanceFlow();
};

</script>


<template>
    <showcase-layout
        title="Review your document"
        :company="companyStore.company"
        :brand="companyStore.brand"
        :location="locationStore.location"
        :company-image-base-url="companyImageBaseUrl"
        showBackButton
        @back-click="navigateToWhatsNext"
    >

        <template #mobileAccent>
            <div class="review-document-candy">
                <img
                    class="review-document-candy__image"
                    :src="'/images/esignature/review-your-document.svg'"
                />
            </div>
        </template>

        <template #branded>
            <showcase-image />
        </template>

        <app-form-content-layout>
            <p>You’re about to open a secure Docusign page where you’ll complete your e-signature request.</p>
            <p>By continuing, you agree to Docusign’s
                <app-link
                    :link-url="LINKS.Docusign.TermsOfUse"
                    type="external"
                    inline
                >Terms of Use</app-link>
            </p>
        </app-form-content-layout>

        <action-bar-layout
            show-back-button
            @back-click="navigateToWhatsNext"
        >
            <app-button
                size="large"
                @onClick="continueFlow"
                data-id="review-document-continue"
            >
                Continue
            </app-button>
        </action-bar-layout>

    </showcase-layout>
</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;

.review-document-candy {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;

    &__image {
        max-width: 11.6875rem;
        max-height: 11rem;

        @include desktop {
            width: 25rem;
            max-width: none;
            max-height: 21.6875rem;
        }
    }

}
</style>
